//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogDetailDealer: () => import('../DialogDetailDealer/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    searchData: {
      default: {}
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      currentTableData: this.tableData,
      rowData: {
        default: () => ({})
      },
      detailDialogVisible: false
    }
  },
  watch: {
    tableData: {
      handler (val) {
        this.currentTableData = val
      },
      immediate: true
    }
  },
  methods: {
  }
}
